webpackJsonp([160870767912026],{

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CurroPitchDeck.446513bd.pdf";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/app icon.ea980cd8.png";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo ideation.d255a8df.png";

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/whiteboard.09b1b40e.png";

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _whiteboard = __webpack_require__(56);
	
	var _whiteboard2 = _interopRequireDefault(_whiteboard);
	
	var _appIcon = __webpack_require__(515);
	
	var _appIcon2 = _interopRequireDefault(_appIcon);
	
	var _logoIdeation = __webpack_require__(55);
	
	var _logoIdeation2 = _interopRequireDefault(_logoIdeation);
	
	var _CurroPitchDeck = __webpack_require__(330);
	
	var _CurroPitchDeck2 = _interopRequireDefault(_CurroPitchDeck);
	
	__webpack_require__(10);
	
	__webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'WorkDetail' },
	    _react2.default.createElement(
	      'div',
	      { className: 'twoColLayout' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          ' Curro '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Curro is a project from a class that I took at Washington University in St. Louis that allows running teams and invidiuals to easily track and log runs while building a community with other users.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          ' ROLE '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I am a UX Designer and Software Developer for this project. I am working with another teammate to brainstorm MVP user interface / experience features, conduct user tests, and implement our designs.'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'pdfButton',
	            href: 'https://apps.apple.com/us/app/curro-activity-logger/id1503599546?ls=1',
	            rel: 'noopener noreferrer',
	            target: '_blank'
	          },
	          'Download on the iOS App Store'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { id: 'runTrackerIcon', className: 'threeQuartersImage', src: _appIcon2.default })
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      ' INSPIRATION '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Curro is a project for a class where students break into teams and are expected to publish an application on the app store.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\'m in a group with 3 other students who are on the track team at WashU, and they\'ve noticed a problem with the website they\'re currently using to log their workouts. After looking at the site, we decided we can build something better.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'twoColLayout' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          ' BRAND IDENTITY '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Honing the brand identity was a process that wasn\'t taken lightly, and we spent multiple weeks iteratively honing how we wanted the product to be perceived by testing against multiple samples of our target users.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I love this graphic below because it perfectly captures our thought process from a bird\'s-eye view -- from initial concept, all the way to "aha" moment.'
	        ),
	        _react2.default.createElement('img', { className: 'twoColImage', src: _logoIdeation2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          ' BRAINSTORMING '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We wanted a platform that can begin as a tool for teams to log workouts and help support each other, but which can grow into something more than that: a place for athletes to build a community of people striving to be better every day.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          ' WIREFRAMES '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We spent a considerable amount of time refining our vision for the product\'s UI. Some of our constraints were:',
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'the brand needs to be somewhat color-agnostic => different users will have different colors in their app based on if they are on a team'
	            )
	          )
	        ),
	        _react2.default.createElement('img', { className: 'twoColImage', src: _whiteboard2.default }),
	        _react2.default.createElement(
	          'h2',
	          null,
	          ' PITCH DECK '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We pitched the idea to our class and professor before starting development'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'pdfButton',
	            rel: 'noopener noreferrer',
	            href: _CurroPitchDeck2.default,
	            target: '_blank' },
	          'our pitch deck'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          ' TECHNOLOGIES USED '
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'XCode'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'SwiftUI, Swift'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'TestFlight'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'GraphQL'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Amazon Web Services (Amplify, Cognito, DynamoDB)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Adobe Illustrator'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-curro-js-31d680af87be87fe806f.js